import { Component,ComponentFactoryResolver,EventEmitter,Input,OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import dxFileUploader from 'devextreme/ui/file_uploader';
import dxForm from 'devextreme/ui/form';
import notify from 'devextreme/ui/notify';
import { FindValueSubscriber } from 'rxjs/internal/operators/find';

import { NicaFileManagerComponent } from '../../components/nica-file-manager/nica-file-manager.component';
import { Apiservice } from '../../services/api.service';
import { Utenteservice } from '../../services/utente.service';
import { FormGroupDirective } from '@angular/forms';

declare const createElements: any;

class Email{

  titolo:string;
  oggetto:string;
  allegati:string;
  messaggio:string
}


@Component({
  selector: 'app-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.css']
})

export class EmailComponent implements OnInit {
  
  
  @Output() outputEvent : EventEmitter<any> = new EventEmitter<any>(); 

  @ViewChild('form', { static: false }) formEmail: dxForm;
  @ViewChild('fileUploader', { static: false }) fileUploader: dxFileUploader;
  @ViewChild('dynamicInsert', { static:false,read: ViewContainerRef }) dynamicInsert: ViewContainerRef;

  files:any; //Provenienti da altri componenti in allegato
  emailData:Email[];
  popupVisible:boolean=true;  
  closeButtonOptions: any;
  buttonOptions:any;
  positionOf: string;
  maxLength:number;
  value: string;
  popupComponentTitle: string;
  popupComponentVisible: boolean;
  componentRef: any;
  fileAttachment:File[];
  fileAttachmentSize:number;
  fileaSize:number=0
  testoHtml:string="";
  filesCaricati:any[] = [];
  nomeCompletoMittente:string="";


  emailButtonOptions = {
    text: "Invia Email",
    //type: "success",
    horizontalAlignment:"right",
    icon:"far fa-paper-plane",
    stylingMode: 'text',
    location: "after",
    widget: "dxButton",
    locateInMenu: "never",
    elementAttr:{id:"bottoneInoltro"},
    onClick:()=>{
      document.getElementById('hiddenBottoneInoltro').click();
    }
  };

  annullaButtonOptions = {
    icon: "glyphicon glyphicon icon-annulla-form",
    text: 'Annulla',
    onClick: () => { this.outputEvent.emit('chiudi') },
    stylingMode: 'text',
    location: "after",
    widget: "dxButton",
    locateInMenu: "never",
    event:''
  };


  hiddenEmailButtonOptions={
    useSubmitBehavior: true,
    elementAttr:{style:"display:none",id:"hiddenBottoneInoltro"},
  }

  constructor(private apiservice:Apiservice,private componentFactoryResolver: ComponentFactoryResolver, private userService : Utenteservice,private routerService:Router) {
    const that = this;    
     
  
   }





  ngOnInit() {
    

    this.onFormSubmit = this.onFormSubmit.bind(this);

    console.log(this.userService.InfoDatiUtenteConnesso.tipoutente)

    this.nomeCompletoMittente=this.userService.InfoDatiUtenteConnesso.tipoutente.toLowerCase() == 'owner' ?  'Owner' : this.userService.InfoUtenteConnesso.tipoutente;// + " " + this.userService.InfoUtenteConnesso.nomeCompleto;
    this.maxLength=500;
    this.value = null;

   



/*   
    setTimeout(
      ()=>{
        if(this.files){
          
          this.filesCaricati.push(this.files);
          
          
        }
      },200
    )

 */  
      
  }


  onFormSubmit = function(e) {
    
    
   
    e.preventDefault();

    
    
    document.getElementById("bottoneInoltro").style.visibility ="hidden";
    $(".emailLoaders").show();


    this.fileaSize = 0
    let form = this.formEmail.instance;  
    let data = form.option("formData") 
    let fileChoosed  = [];

   
    let Datifiles = []

    
    
    let formData = new FormData(); 
    


    formData.append('mittente', this.nomeCompletoMittente);//this.userService.InfoDatiUtenteConnesso.nomeCompleto
    formData.append('destinatario', data.email);
    formData.append('oggetto', data.oggetto);
    formData.append('messaggio', this.testoHtml);
    
    
     
    Datifiles.push({
      email:data.email,
      oggetto:data.oggetto,
      messaggio:data.messaggio,
      files: this.attachedFiles(this.fileUploader,fileChoosed)
     
    })

  
    
    if(this.files){
     
      (Datifiles[0].files as any[]).push(this.files);

      //this.files = undefined;
    }

    
  
    for(let file of Datifiles[0].files){
      
      if(file["type"]==="application/pdf" && !(file["name"] as string).endsWith(".pdf")){
        var blob = file.slice(0, file.size, "application/pdf");
        let nomeFile = (file["name"] as string).concat(".pdf");
        file = new File([blob],nomeFile,{type:"application/pdf"}); 
        
      }


      formData.append("file",file);
    }

   

    let status =''
    let message ='';
    let check = this.fileaSize < 10485760;
    
    if(check){

      (this.apiservice.invioEmail(formData) as Promise<any>)
      .then(
        (result)=>{
        

         setTimeout(
           ()=>{ 
            $(".emailLoaders").hide();
            document.getElementById("bottoneInoltro").style.visibility ="visible";
            
            Datifiles = [];
            
            
            notify({
              message: result,
              position: {
                  my: "center bottom",
                  at: "center bottom"
              }
            }, "success", 3000);
            

          },
           5000
         )
        

        })       
      .catch(
        (error)=> {; 
        
          setTimeout(
            ()=>{ 
              $(".emailLoaders").hide();
              document.getElementById("bottoneInoltro").style.visibility ="visible";

              Datifiles = [];

              
            },
            5000
          );

          
          switch(error.status as number){


            case 400:{


              
              notify({
                message: (error.error as string).includes("invalid destination domain") ? `Dominio "${(data.email as string).split('@')[1]}" non valido!` : "Errore Sconosciuto",
                position: {
                    my: "center bottom",
                    at: "center bottom"
                }
              }, "error", 3000);
              




            }
          }
          
          //console.log("errore: ", error);  



          
         
      
        });
      
        
      




    }else{
     
      status ='error';
      message = 'Hai superato la dimensione massima di 10 mb degli allegati';
      
      $(".emailLoaders").hide();
      document.getElementById("bottoneInoltro").style.visibility ="visible";
      
      Datifiles = [];

      notify({
        message: message,
        position: {
            my: "center bottom",
            at: "center bottom"
        }
      }, status, 3000);


    }
    
    //console.log(check)
    
    
    
    
    e.preventDefault();
  }

  attachedFiles(filesComponent,choosed){
    //console.log(choosed)
    
      let arrayAttached=choosed;
      for (const file of filesComponent.value) { 
        //console.log(file)
        this.fileaSize += file.size;
       
        //formData.append(file.name, file);  
    
        arrayAttached.push(file)
      } 
      //console.log(arrayAttached)
      return arrayAttached;
   
    
  }
  

  FileManagerOpen(){
    this.popupComponentTitle="File Manager";
    this.popupComponentVisible = true;

    const factory2 = this.componentFactoryResolver.resolveComponentFactory(NicaFileManagerComponent);
    
    setTimeout(() => {
        
        this.dynamicInsert.clear();
        
        this.componentRef  = this.dynamicInsert.createComponent(factory2, 0);
        this.componentRef.instance.outputEvent.subscribe(val => {
          

          if(val){
            let el = document.querySelector('#fromFileManager');
            el.innerHTML = "";
            const result = createElements('div');
            

            val.forEach(v=>{
              
              let element = null;
              let content = v.name + '\r\n';
              content += `${(v.size / 1024).toFixed(0)} kb`;
              element = createElements('span',content,'info-files',v.name);
              //console.log(element);
              result.appendChild(element);

            })
          
            this.fileAttachment = result;
            
            
            //console.log(result)
            el.appendChild(result);
            this.popupComponentVisible = false;
          }
        })
    }, 100);
    
   
    
}

  getSize(bytes,decimals = 2){
    
    
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    this.fileAttachmentSize = bytes;
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    
  }
  getClass(type){


    let classes = '';

    switch (type) {
      case "application/pdf":
        return 'far fa-file-pdf'
      case "application/vnd.ms-powerpoint":
        return "far fa-file-powerpoint";
      case "application/vnd.ms-excel":
        return "far fa-file-excel"
      case "application/zip":
        return "far fa-file-archive"
      case "application/msword":
          return "far fa-file-word";
      

      default:
          return "far fa-file-alt";
    }

  }

 

  //Appena viene lanciato questo metodo si perdono tutti i vecchi files
    onValueChanged(e){

    let t=this;
    //this.filesCaricati.shift();

    console.log("pippo è stato qui")

    for(let i=0;i<document.getElementsByClassName("dx-fileuploader-button dx-fileuploader-upload-button dx-button dx-button-normal dx-button-mode-contained dx-widget dx-button-has-text").length;i++){

      document.getElementsByClassName("dx-fileuploader-button dx-fileuploader-upload-button dx-button dx-button-normal dx-button-mode-contained dx-widget dx-button-has-text").item(i).remove();

    }

    /*
    let cestino = document.createElement("i");

    cestino.setAttribute("class","bi bi-trash-fill");

    cestino.style.fontSize="20px";
    cestino.style.width="30px";
    cestino.style.height="30px";
    cestino.style.backgroundColor = "#004C75";
    cestino.style.color="white";
    cestino.style.textAlign="center";
    //cestino.style.position="absolute";
    //cestino.style.right="30%";
    cestino.style.marginLeft="10px";
    (cestino.style as any).float="right";
    cestino.style.borderRadius="50%";
    cestino.style.paddingTop="5px";
    cestino.title="Elimina Allegato";

    cestino.onmouseover = ()=>{
      cestino.style.backgroundColor = "lightgrey";
      cestino.style.color="black";
      cestino.style.cursor="pointer";
      
    }

    cestino.onmouseleave = ()=>{
      cestino.style.backgroundColor = "#004C75";
      cestino.style.color="white";
      cestino.style.cursor="";
      
    }
    */

    for(let i=0;i<document.getElementsByClassName("dx-fileuploader-file-container").length;i++){

      if(document.getElementsByClassName("dx-fileuploader-file-container").item(i).children.item(1).className=="dx-fileuploader-button-container")
          document.getElementsByClassName("dx-fileuploader-file-container").item(i).children.item(1).remove(); //Vado ad eliminare il pulsante di caricamento singolo

      //Ora bisogna cambiare l'aspetto della crocetta

      
      (document.getElementsByClassName("dx-fileuploader-file-container").item(i).children.item(0).children.item(0).children.item(0).children.item(0) as HTMLElement).title="Elimina Allegato";
      document.getElementsByClassName("dx-fileuploader-file-container").item(i).children.item(0).children.item(0).children.item(0).children.item(0).className="bi bi-trash-fill";
      (document.getElementsByClassName("dx-fileuploader-file-container").item(i).children.item(0).children.item(0).children.item(0).children.item(0) as HTMLElement).style.fontSize="14px";

     // document.getElementsByClassName("dx-fileuploader-file-container").item(i).children.item(0).children.item(0).children.item(0).children.item(0) as HTMLElement
    }

    


    //console.log((this.fileUploader.instance as any)._files);

    //this.filesCaricatiTemp = this.filesCaricati.concat(this.filesCaricati);
   
   
  }


/*
  eliminaFileByIndice(indice:number){

    if(this.filesCaricati[indice]){
      this.filesCaricati.splice(indice,1);
    }

  }
*/



  
}
